import CreditReportLink from '~/common/components/Credit/CreditReportLink';
import PDFViewerWithIframe from '~/common/components/PDFViewerWithIframe/PDFViewerWithIframe';
import ConvertCreditQualifyingButton from '~/modals/PITI/ConvertCreditQualifyingButton';

import Accordion from './Accordion/Accordion';
import ActiveFieldBackground from './ActiveFieldBackground/ActiveFieldBackground';
import Alert from './Alert/Alert';
import AssetsAmountMismatchAlert from './Alert/AssetsAmountMismatchAlert';
import EffectiveDateAlert from './Alert/EffectiveDateAlert';
import Box from './Box/Box';
import BreakdownSummation from './BreakdownSummation';
import Button from './Button/Button';
import CalculationHistory from './CalculationHistory/CalculationHistory';
import ChakraTable from './ChakraTable';
import DynamicTable from './ChakraTable/DTable';
import KYLTable from './ChakraTable/KYLTable';
import KYLTableRow from './ChakraTable/KYLTableRow';
import ChakraTableRow from './ChakraTable/TableRow';
import { Checkbox, CheckboxGroup } from './Checkbox';
import CommentBox from './CommentBox';
import Datalist from './Datalist';
import Divider from './Divider/Divider';
import DownloadLink from './DownloadLink/DownloadLink';
import FieldArrayCustom from './FieldArray/FieldArrayCustom';
import Form from './Form/Form';
import FullPageWithPDFViewer from './FullPageWithPDFViewer/FullPageWithPDFViewer';
import Grid from './Grid/Grid';
import HiddenElement from './HiddenElement/HiddenElement';
import ExtractionStatusIcon from './Icon/ExtractionStatusIcon';
import Icon from './Icon/Icon';
import Input from './Input/Input';
import Modal from './Modal/Modal';
import YAMLOops from './Oops/Oops';
import { Page } from './Page';
import PDFViewer from './PdfViewer/PDFViewer';
import QuestionBox from './QuestionBox/QuestionBox';
import QuestionExtraction from './QuestionExtraction';
import ExtractionDataIcon from './QuestionExtraction/components/ExtractionDataIcon';
import { Radio } from './Radio';
import RadioButton from './RadioButton';
import CustomSelectWithStyledOptions from './Select/CustomSelectWithStyledOptions';
import MultiSelect from './Select/MultiSelect';
import Select from './Select/Select';
import Stack from './Stack';
import Table, { TableRow } from './Table';
import Text from './Text/Text';
import ToggleButton from './ToggleButton';

const componentMapper = {
  Alert: Alert,
  Accordion: Accordion,
  Radio: Radio,
  Input: Input,
  RadioButton,
  Datalist,
  Dialog: Modal,
  DownloadLink: DownloadLink,
  Button: Button,
  ToggleButton,
  BreakdownSummation: BreakdownSummation,
  Checkbox: Checkbox,
  Box: Box,
  Stack,
  Form: Form,
  Grid: Grid,
  Select: Select,
  MultiSelect: MultiSelect,
  Page: Page,
  Text: Text,
  CreditReportLink: CreditReportLink,
  DynamicTable: DynamicTable,
  KYLTableRow: KYLTableRow,
  KYLTable: KYLTable,
  ChakraTable: ChakraTable,
  ChakraTableRow: ChakraTableRow,
  Table,
  TableRow,
  CommentBox: CommentBox,
  CheckboxGroup: CheckboxGroup,
  FieldArrayCustom: FieldArrayCustom,
  Icon: Icon,
  ExtractionDataIcon: ExtractionDataIcon,
  QuestionBox: QuestionBox,
  QuestionExtraction: QuestionExtraction,
  FullPageWithPDFViewer: FullPageWithPDFViewer,
  PDFViewer: PDFViewer,
  PDFViewerWithIframe: PDFViewerWithIframe,
  EffectiveDateAlert: EffectiveDateAlert,
  AssetsAmountMismatchAlert: AssetsAmountMismatchAlert,
  YAMLOops: YAMLOops,
  Divider: Divider,
  ActiveFieldBackground: ActiveFieldBackground,
  HiddenElement: HiddenElement, //INFO: will be removed after Title Refi pilot
  ExtractionStatusIcon,
  CustomSelectWithStyledOptions: CustomSelectWithStyledOptions,
  CalculationHistory: CalculationHistory,
  ConvertCreditQualifyingButton: ConvertCreditQualifyingButton,
};
export { FormTemplateWithAuditHistory } from './FormTemplate';
export { FormTemplate } from './FormTemplate';
export default componentMapper;
